import { createSelector } from 'reselect';

const selectuser = (state) => state.user;

export const selectCurrentItem = createSelector([selectuser], (user) => user.current);

export const selectCurrentItemEmail = createSelector([selectuser], (user) => user);

export const selectListItems = createSelector([selectuser], (user) => user.list);

// The badge on the Settings > Users tab counts the workspace, not the page: items only
// ever holds one page, so it would read 25 for a 30-user workspace and change as the
// table paginates. total_records survives RESET_LIST too, so the count stays put while
// a refetch is in flight.
//
// The fallback is what runs today: `GET /workspace/users` answers `{users: [...]}` with no
// pagination block at all, whatever page and total are asked for, so there is no count to
// prefer yet. It is preferred the moment the route reports one.
export const selectListUsersLength = createSelector(
  [selectuser],
  (user) => user?.list?.result?.pagination?.totalRecords ?? user?.list?.result?.items?.length
);

export const visibilityColumnsList = createSelector([selectuser], (user) => user.visibility);

export const selectItemById = (itemId) =>
  createSelector(selectListItems, (list) => list.result.items.find((item) => item._id === itemId));

export const selectCreatedItem = createSelector([selectuser], (user) => user.create);

export const selectUpdatedItem = createSelector([selectuser], (user) => user.update);

export const selectReadItem = createSelector([selectuser], (user) => user.read);

export const selectDeletedItem = createSelector([selectuser], (user) => user.delete);

export const selectSearchedItems = createSelector([selectuser], (user) => user.search);

export const filter = createSelector([selectuser], (user) => user.filter);